import { onBeforeUnmount, onMounted } from 'vue';
import { debounce, MediaQuery, MediaQueryService } from '@workbench/core';

export const BREAKPOINTS: Record<MediaQuery, number> = {
  mq1: 320,
  mq2: 480,
  mq3: 768,
  mq4: 1024,
  mq5: 1280,
  mq6: 1440,
};

const mediaQueryService = new MediaQueryService(window);

export const onWindowResize = (callback) => {
  const _callback = debounce(callback, 300);

  onMounted(() => {
    viewPortService.addResizeEventListener(_callback);
  });

  onBeforeUnmount(() => {
    viewPortService.removeResizeEventListener(_callback);
  });
};

export const viewPortService = {
  getCurrentBreakpoint() {
    return mediaQueryService.getCurrentMediaQuery().toLowerCase();
  },

  addResizeEventListener(callback) {
    window.addEventListener('wbresize', callback);
    // pass in `true` if you are interested in the media query in the moment of calling the function
    mediaQueryService.observe(true);
  },

  removeResizeEventListener(callback) {
    window.removeEventListener('wbresize', callback);
    // when you don't need to observe anymore
    mediaQueryService.disconnect();
  },

  isSmallerMobile() {
    return ['mq1', 'mq2', 'mq3'].includes(viewPortService.getCurrentBreakpoint());
  },

  isMobile() {
    return ['mq1', 'mq2', 'mq3', 'mq4'].includes(viewPortService.getCurrentBreakpoint());
  },

  isDesktop() {
    return ['mq5', 'mq6'].includes(viewPortService.getCurrentBreakpoint());
  },

  isBreakpoint(breakpointList: Array<string> = []) {
    return breakpointList.includes(viewPortService.getCurrentBreakpoint());
  },
};
